import { render } from "./creditNoteForm.vue?vue&type=template&id=d213e872&scoped=true"
import script from "./creditNoteForm.vue?vue&type=script&lang=js"
export * from "./creditNoteForm.vue?vue&type=script&lang=js"

import "./creditNoteForm.vue?vue&type=style&index=0&id=d213e872&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d213e872"]])

export default __exports__